import styled from '@mui/material/styles/styled';
import TableContainer from '@mui/material/TableContainer';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TextFieldBase from '@mui/material/TextField';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { MuiChipsInput } from 'mui-chips-input'

import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => `
  & {
    border-radius: 0px;
    border-bottom-left-radius: ${theme.shape.borderRadius}px;
    border-bottom-right-radius: ${theme.shape.borderRadius}px;
    box-shadow: ${theme.palette.lightBoxShadow};
  }
  & .MuiTableCell-root {
    font-size: 12px;
    padding: 5px;
  }
`);

export const StyledSortableTableCell = styled(TableCell)(({ theme }) => `
  & {
    cursor: pointer;
  }
`);

export const StyledArrowUpwardIcon = styled(KeyboardArrowUpIcon)(({ theme }) => `
  & {
    vertical-align: middle;
    font-size: 12px !important;
  }
`);

export const StyledArrowDownwardIcon = styled(KeyboardArrowDownIcon)(({ theme }) => `
  & {
    vertical-align: middle;
    font-size: 12px !important;
  }
`);

export const StyledTableHead = styled(TableHead)(({ theme }) => `
  & .MuiTableCell-root {
    font-weight: bolder;
  }
`);

export const CMSmallTextField = styled(TextFieldBase)(({ theme }) => `
  & .MuiFormControl-root {
    margin-top: 4px !important;
  }
  & .MuiInputBase-root {
    font-size: 14px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    font-family: ${theme.typography.fontFamily};
  }
  & .MuiInputLabel-root {
    font-family: ${theme.typography.fontFamily};
    font-size: 12px;
    top: -8px;
  }
  &.MuiTextField-root {
    margin-bottom: 6px !important;
  }
  & .MuiInputBase-input {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  & .MuiInputLabel-outlined {
    padding: 0px;
  }
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
    top: 0px;
  }
  & .MuiFormHelperText-root {
    font-size: 10px;
    padding: 0px;
    opacity: 0.6;
    margin: 0px;
    margin-left: 4px;
  }
`);

export const CMSmallChipsField = styled(MuiChipsInput)(({ theme }) => `
  & .MuiFormControl-root {
    margin-top: 4px !important;
  }
  & .MuiInputBase-root {
    font-size: 14px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    font-family: ${theme.typography.fontFamily};
  }
  & .MuiInputLabel-root {
    font-family: ${theme.typography.fontFamily};
    font-size: 12px;
    top: -8px;
  }
  & .MuiChipsInput-Chip {
    font-size: 10px;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }
  &.MuiTextField-root {
    margin-bottom: 6px !important;
  }
  & .MuiInputBase-input {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  & .MuiInputLabel-outlined {
    padding: 0px;
  }
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
    top: 0px;
  }
  & .MuiFormHelperText-root {
    font-size: 10px;
    padding: 0px;
    opacity: 0.6;
    margin: 0px;
    margin-left: 4px;
  }
`);

export const CMSmallTextArea = styled(BaseTextareaAutosize)(({ theme }) => `
  resize: none;
  box-sizing: border-box;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  color: ${theme.palette.text.primary};
  background: inherit;
  border: 1px solid ${theme.palette.divider};
  font-family: ${theme.typography.fontFamily} !important;
  font-size: 12px;
  border-radius: 4px;
  margin-bottom: 4px;
  
  &:hover {
    border-color: ${theme.palette.divider};
  }

  &:focus {
    border-color: ${theme.palette.primary.main};
    box-shadow: 0 0px 4px rgba(0, 0, 0, 0.35);
  }
`);

export const CMFormControlLabel = styled(FormControlLabel)(({ theme }) => ``);

export const CMFormControl = styled(FormControl)(({ theme }) => `
  & .MuiInputBase-root {
    font-size: 14px;
    height: 32px;
    font-family: ${theme.typography.fontFamily};
  }
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    display: inline-block;
    top: 0px;
  }
  & .MuiInputLabel-root {
    background-color: ${theme.palette.background.paper};
    height: 20px;
    top: -8px;
    padding-right: 5px;
    padding-left: 5px;
    font-size: 12px;
    font-family: ${theme.typography.fontFamily};
  }
`);

export const CMFormControlDark = styled(FormControl)(({ theme }) => `
  margin-bottom: 8px;
  
  & .MuiInputBase-root {
    font-size: 14px;
    height: 40px;
    font-family: ${theme.typography.fontFamily};
    background-color: ${theme.palette.background.inputDark || '#292929'};
    border: 1px solid ${theme.palette.divider};
    border-radius: 4px;
  }
  
  & .MuiInputBase-root:hover {
    background-color: ${theme.palette.background.inputDarkHover || '#333333'};
  }
  
  & .MuiInputBase-root.Mui-focused {
    background-color: ${theme.palette.background.inputDark || '#292929'};
  }
  
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    display: inline-block;
    transform: translate(14px, -6px) scale(0.75);
    top: 0px;
    background-color: ${theme.palette.background.paper};
    padding: 0 5px;
  }
  
  & .MuiInputLabel-root {
    transform: translate(14px, 12px) scale(1);
    height: 20px;
    font-size: 14px;
    font-family: ${theme.typography.fontFamily};
  }
  
  & .MuiSelect-select {
    display: flex;
    align-items: center;
    padding: 8px 14px;
  }
  
  & .MuiOutlinedInput-input {
    padding: 10px 14px;
    display: flex;
    align-items: center;
    height: 20px;
    line-height: 20px;
  }
  
  & .MuiInputBase-input {
    display: flex;
    align-items: center;
  }
  
  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`);

export const CMSelect = styled(Select)(({ theme }) => ``);

export const CMNFormControl = styled(FormControl)(({ theme }) => `
  & {
    font-size: 48px !important;
    padding: 3px;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: 0px solid ${theme.palette.divider} !important;
    border-radius: 18px;
    border-radius: 0px;
  }

  & .MuiSvgIcon-root:last-child {
    display: none !important;
  }

  & .MuiSvgIcon-root:first-of-type {
    position: absolute !important;
    top: 15px;
    left: 16px;
    font-size: 18px;
    color: ${theme.palette.text.secondary};
    z-index: 1;
  }

  & .MuiInputBase-root {
    font-size: 12px;
    height: 32px;
    margin-top: 4px !important;
    padding-left: 24px;
    border-radius: 18px;
    background-color: ${theme.palette.background.paper};
  }
  
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    display: inline-block;
    top: 0px;
  }

  & .MuiInputLabel-root {
    background-color: ${theme.palette.background.paper};
    height: 20px;
    top: -8px;
    padding-right: 5px;
    padding-left: 5px;
    font-size: 12px;
    font-family: ${theme.typography.fontFamily};
  }
`);

export const CMAccordion = styled(Accordion)(({ theme }) => `
  &.MuiPaper-root {
    box-shadow: none !important;
    padding: 0px;
  }

  & .MuiAccordionSummary-root {
    padding: 0px;
    min-height: 0px !important;
    margin-top: 8px !important;
    display: flex;
  }

  & .MuiTypography-root {
    font-size: 12px !important;
  }
`);

export const CMAccordionSummary = styled(AccordionSummary)(({ theme }) => `
  &.MuiAccordionSummary-root {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(180deg);
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
  }
`);

export const CMChip = styled(Chip)(({ theme }) => `
  &.MuiChip-root {
    height: 20px;
    font-size: 12px;
  }
`);

export const CMButtonOutlinedSmall = styled(Button)(({ theme }) => `
  box-shadow: none;
  text-transform: none;
  font-size: 10px;
  color: ${theme.palette.primary.dark};
  font-weight: bold;
  padding: 6px 12px;
  border: 1px solid;
  height: 30px;
  padding-right: 20px;
  border-radius: ${theme.shape.buttonBorderRadius}px;
  line-height: 1.5;
  background-color: ${theme.palette.background.paper};
  border-color: ${theme.palette.primary.main};
  font-family: ${theme.typography.fontFamily};
  
  &:hover {
    background-color: ${theme.palette.background.paper};
    border-color: ${theme.palette.primary.dark};
    box-shadow: none;
  }
  
  &:active {
    box-shadow: none;
    background-color: ${theme.palette.background.paper};
    border-color: ${theme.palette.primary.dark};
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.5);
  }
`);

export const CMButtonOutlined = styled(Button)(({ theme }) => `
  box-shadow: none;
  text-transform: none;
  font-size: 14px;
  color: ${theme.palette.primary.dark};
  font-weight: bold;
  padding: 6px 12px;
  border: 1px solid;
  height: 40px;
  padding-right: 20px;
  border-radius: ${theme.shape.buttonBorderRadius}px;
  line-height: 1.5;
  background-color: ${theme.palette.background.paper};
  border-color: ${theme.palette.primary.main};
  font-family: ${theme.typography.fontFamily};
  
  &:hover {
    background-color: ${theme.palette.background.paper};
    border-color: ${theme.palette.primary.dark};
    box-shadow: none;
  }
  
  &:active {
    box-shadow: none;
    background-color: ${theme.palette.background.paper};
    border-color: ${theme.palette.primary.dark};
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.5);
  }
`);

export const CMButton = styled(Button)(({ theme }) => `
  box-shadow: none;
  text-transform: none;
  font-size: 14px;
  color: ${theme.palette.primary.contrastText};
  font-weight: bold;
  padding: 6px 12px;
  border: 1px solid;
  height: 40px;
  padding-right: 20px;
  border-radius: ${theme.shape.buttonBorderRadius}px;
  line-height: 1.5;
  background-color: ${theme.palette.primary.main};
  border-color: ${theme.palette.primary.main};
  font-family: ${theme.typography.fontFamily};
  
  &:hover {
    background-color: ${theme.palette.primary.dark};
    border-color: ${theme.palette.primary.dark};
    box-shadow: none;
  }
  
  &:active {
    box-shadow: none;
    background-color: ${theme.palette.primary.dark};
    border-color: ${theme.palette.primary.dark};
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.5);
  }

  /* MUI's default ".Mui-disabled" rule overrides "color" with a low-
     contrast grey while leaving the primary background in place,
     which produces unreadable grey-on-green for any disabled CMButton
     (e.g. the "Subscribed" CTA on Marketplace listing detail). Keep
     the contrastText color and dim the whole button uniformly so the
     label stays legible across light + dark themes. */
  &.Mui-disabled {
    color: ${theme.palette.primary.contrastText};
    background-color: ${theme.palette.primary.main};
    border-color: ${theme.palette.primary.main};
    opacity: 0.6;
  }
`);

export const CMButtonSuccess = styled(Button)(({ theme }) => `
  box-shadow: none;
  text-transform: none;
  font-size: 14px;
  color: ${theme.palette.success.contrastText};
  font-weight: bold;
  padding: 6px 12px;
  border: 1px solid;
  height: 40px;
  padding-right: 20px;
  border-radius: ${theme.shape.buttonBorderRadius}px;
  line-height: 1.5;
  background-color: ${theme.palette.success.main};
  border-color: ${theme.palette.success.main};
  font-family: ${theme.typography.fontFamily};
  
  &:hover {
    background-color: ${theme.palette.success.dark};
    border-color: ${theme.palette.success.dark};
    box-shadow: none;
  }
  
  &:active {
    box-shadow: none;
    background-color: ${theme.palette.success.dark};
    border-color: ${theme.palette.success.dark};
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem ${theme.palette.success.light};
  }

  /* See CMButton: keep contrastText readable when disabled instead of
     letting MUI's grey-text default land on a coloured background. */
  &.Mui-disabled {
    color: ${theme.palette.success.contrastText};
    background-color: ${theme.palette.success.main};
    border-color: ${theme.palette.success.main};
    opacity: 0.6;
  }
`);

export const CMButtonError = styled(Button)(({ theme }) => `
  box-shadow: none;
  text-transform: none;
  font-size: 14px;
  color: ${theme.palette.error.contrastText};
  font-weight: bold;
  padding: 6px 12px;
  border: 1px solid;
  height: 40px;
  padding-right: 20px;
  border-radius: ${theme.shape.buttonBorderRadius}px;
  line-height: 1.5;
  background-color: ${theme.palette.error.main};
  border-color: ${theme.palette.error.main};
  font-family: ${theme.typography.fontFamily};
  
  &:hover {
    background-color: ${theme.palette.error.dark};
    border-color: ${theme.palette.error.dark};
    box-shadow: none;
  }
  
  &:active {
    box-shadow: none;
    background-color: ${theme.palette.error.dark};
    border-color: ${theme.palette.error.dark};
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem ${theme.palette.error.light};
  }

  /* See CMButton: keep contrastText readable when disabled instead of
     letting MUI's grey-text default land on a coloured background. */
  &.Mui-disabled {
    color: ${theme.palette.error.contrastText};
    background-color: ${theme.palette.error.main};
    border-color: ${theme.palette.error.main};
    opacity: 0.6;
  }
`);

export const CMTextareaLLM = styled(BaseTextareaAutosize)(({ theme }) => `
  resize: none;
  box-sizing: border-box;
  width: 620px;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px 20px;
  padding-right: 80px !important;
  color: ${theme.palette.text.primary};
  background: ${theme.palette.background.paper};
  border: 1px solid ${theme.palette.divider};
  font-family: ${theme.typography.fontFamily};
  border-radius: ${theme.shape.borderRadius}px;
  box-shadow: ${theme.palette.lightBoxShadow};

  &:hover {
    border-color: ${theme.palette.divider};
  }

  &:focus {
    border-color: ${theme.palette.divider};
    box-shadow: 0 0px 4px rgba(0, 0, 0, 0.35);
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`);

export const CMButtonLLM = styled(Button)(({ theme }) => `
  float: right;
  margin-top: -44px;
  margin-right: 20px;
  box-shadow: none;
  text-transform: none;
  font-size: 12px;
  color: ${theme.palette.primary.contrastText};
  min-width: 40px;
  text-align: center;
  font-weight: bold;
  padding: 0px;
  border: 1px solid;
  height: 34px;
  padding-right: 8px;
  border-radius: ${theme.shape.borderRadius}px;
  line-height: 1.5;
  background-color: ${theme.palette.primary.main};
  border-color: ${theme.palette.primary.main};
  font-family: ${theme.typography.fontFamily};
  
  &:hover {
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
    border-color: ${theme.palette.primary.dark};
    box-shadow: none;
  }
  
  &:active {
    box-shadow: none;
    background-color: ${theme.palette.background.paper};
    border-color: ${theme.palette.primary.dark};
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.5);
  }
`);